export default {
	modules: {
		navigator: {
			strict: true,
			namespaced: true,
			state: {
				stack: [],
				options: {
					animation: 'fade',
					animationOptions: {duration: 0.2, timing: 'ease-in'}
				}
			},
			mutations: {
				push(state, page) {
					state.stack.push(page);
				},
				pop(state) {
					if (state.stack.length > 1) {
						state.stack.pop();
					}
				},
				replace(state, page) {
					state.stack.pop();
					state.stack.push(page);
				},
				reset(state, page) {
					state.stack = [page || state.stack[0]];
				},
				options(state, newOptions = {}) {
					state.options = newOptions;
				}
			}
		},

		splitter: {
			strict: true,
			namespaced: true,
			state: {
				open: false
			},
			mutations: {
				toggle(state, shouldOpen) {
					if (typeof shouldOpen === 'boolean') {
						state.open = shouldOpen;
					} else {
						state.open = !state.open;
					}
				}
			}
		},

		tabbar: {
			strict: true,
			namespaced: true,
			state: {
				index: 1
			},
			mutations: {
				set(state, index) {
					state.index = index;
				},
			}
		},
		shared: {
			strict: true,
			namespaced: true,
			state: {
				isLoggedIn: false,
				avatar: '',
				names: '',
				startTimer: false,
				homeTabIndex: 0,
			},
			mutations: {
				set(state, index) {
					state.index = index;
				},
				setUserAvatar(state, data) {
					state.avatar = data;
				},
				setUserNames(state, data) {
					state.names = data;
				},
				setTimerState(state, data){
					state.startTimer = data;
				},
				setHomeTabIndex(state, data){
					state.homeTabIndex = data;
				}
			}
		},
		collections: {
			strict: true,
			namespaced: true,
			state: {
				selectedFilters: [],
			},
			mutations: {
				addFilterValue(state, data){
					let updatedExisting = false;
					state.selectedFilters.forEach(function(oneFilter, index){
						if(oneFilter.id === data.id){
							state.selectedFilters[index] = data;
							updatedExisting = true;
						}
						state.selectedFilters = [...state.selectedFilters];
					});
					if(!updatedExisting){
						state.selectedFilters.push(data);
					}
				},
				resetFilters(state){
					state.selectedFilters = [];
				},
			},
			getters: {
				activeFilters(state){
					return state.selectedFilters;
				}
			}
		},
		version: {
			state: process.env.VUE_APP_VERSION
		},
	}
};
